import { MaiFeedbackReason } from '~/lib/types/mai/MaiFeedbackReason';

export const MAI_FEEDBACK_REASON_OPTIONS: Array<{
  label: string;
  value: MaiFeedbackReason;
}> = [
  { label: 'Inaccurate or incorrect', value: 'inaccurate' },
  { label: 'Irrelevant or not useful', value: 'irrelevant' },
  { label: 'Missing or unclear source citation', value: 'missing_citation' },
  {
    label: 'Clinically inappropriate suggestion',
    value: 'clinically_inappropriate',
  },
  { label: 'Incomplete response', value: 'incomplete' },
  { label: 'Confusing or poorly explained', value: 'confusing' },
  { label: 'Slow or technical issue', value: 'slow_or_technical' },
  {
    label: 'Feature request (Maud AI can’t do this yet)',
    value: 'feature_request',
  },
  { label: 'Other', value: 'other' },
];

export const MAI_FEEDBACK_COMMENT_LIMIT = 420;

export const MAI_FEEDBACK_MODAL_TITLE = 'Provide feedback';
export const MAI_FEEDBACK_MODAL_BODY =
  'We’re always working to improve the quality of our Maud AI responses and your input is essential. If you have any additional information to provide, please do so below.';
export const MAI_FEEDBACK_REASON_LABEL =
  'What didn’t you like about this response?';
export const MAI_FEEDBACK_COMMENT_LABEL = 'Any additional feedback?';

export const MAI_FEEDBACK_SUCCESS_TOAST = 'Thank you for your feedback';
export const MAI_FEEDBACK_RETRACTED_TOAST = 'Your feedback was removed';
export const MAI_FEEDBACK_ERROR_TOAST =
  'An unexpected error occurred submitting your feedback';

export const MAI_FEEDBACK_LABELS = {
  helpful: {
    active: 'Remove helpful rating',
    idle: 'Mark response as helpful',
  },
  notHelpful: {
    active: 'Remove not helpful rating',
    idle: 'Mark response as not helpful',
  },
};
